import { render, staticRenderFns } from "./FrameworkButtons.vue?vue&type=template&id=81b15980"
import script from "./FrameworkButtons.vue?vue&type=script&lang=js"
export * from "./FrameworkButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports